import styled from "styled-components";

export const AutocompleteContainer = styled.div`
	width: 100%;

	& .MuiAutocomplete-root {
		& .MuiSvgIcon-root {
			color: ${({ theme }) => theme.pantone2726C};
		}

		& .MuiAutocomplete-popupIndicator:not(.Mui-disabled) {
			z-index: 1;

			& .MuiSvgIcon-root {
				background: white;
			}
		}

		& .MuiInputBase-root {
			height: 40px;
			background: white;
			border: 1px solid ${({ theme }) => theme.grayDark};
			border-radius: 10px;
			overflow: hidden;
			font-size: 0.875rem;
			padding: 0 !important;

			&.MuiInput-underline:before {
				border-bottom: none;
			}
			&.MuiInput-underline:hover:before {
				border-bottom: none !important;
			}
			&.Mui-disabled {
				background-color: ${({ theme }) => theme.disabled};
				color: rgba(0, 0, 0, 0.38);
			}
		}

		& .MuiInputBase-input {
			font: inherit;
			font-size: 0.875rem;
			letter-spacing: normal;
			height: 100%;
			color: #000;

			&::placeholder {
				color: #000;
			}
		}

		& .MuiAutocomplete-endAdornment {
			right: 7px !important;
		}
	}
`;
